import React from 'react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section aria-labelledby="pain-title" className="border-y-2 border-ink bg-cream" data-id="element-124" data-mp="2ln2ioh7pbrtp">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 py-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:py-24" data-id="element-125" data-mp="26yfrni8ppbmn">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-126" data-mp="2bx95xcvtp6nv">
          <h2 id="pain-title" className="font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-127" data-mp="2bvodbst2jxsn">
            ¿Te suena familiar esto?
          </h2>
          <p className="mt-4 max-w-sm text-ink-soft" data-id="element-128" data-mp="220ec37ahvufx">
            Si te reconociste en al menos una de estas líneas, este diario fue hecho pensando en ti.
          </p>
        </div>
        <ul className="divide-y divide-dashed divide-kraft-dark/40 border-y border-dashed border-kraft-dark/40" data-id="element-129" data-mp="1sxv82juz3bs3">
          {painPoints.map(p => <li key={p.lead} className="flex gap-3 py-4 sm:gap-4 sm:py-6" data-id="element-130" data-mp="3ie4e88i208mx">
              <span aria-hidden="true" className="mt-1.5 h-4 w-4 shrink-0 rounded-[4px] border-2 border-ink" data-id="element-131" data-mp="3nbmruc70nc19" />
              <p className="text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-132" data-mp="1yzdmikt6g9m0">
                <strong className="font-bold text-ink" data-id="element-133" data-mp="1u2dew5goiyss">{p.lead}</strong> {p.rest}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}